import React from "react";
import { Link } from "react-router-dom";
import { Typography, Tabel, Button } from "../core";
import styled from "styled-components";
import { theme } from "../styles";
const CHANGE_DATE_FORMAT = require("../helper/utils/datFormat");

const { colors } = theme;
const typoProps = {
  align: "center",
  text: "Print Report",
  as: "h6",
  lineHeight: "22px",
  weight: "600",
  color: "white",
};
const btnProps = {
  bg: colors.pink,
  radius: "5px",
  height: "30px",
  width: "155px",
  margin: "unset",
};

const columns = [
  {
    title: "Contract #",
    dataIndex: "contract_no",
    key: "contract#",
    width: 150,
  },
  {
    title: "Payment Date",
    dataIndex: "payment_date",
    key: "payment_date",
    render: (text, record) =>
      CHANGE_DATE_FORMAT.changeDateFormat(record.payment_date),
    width: 150,
  },
  {
    title: "Amount/Rs",
    dataIndex: "payment_amount",
    key: "payment_amount",
    width: 150,
  },
  {
    title: "Payment method",
    dataIndex: "payment_method",
    key: "payment_method",
    width: 150,
  },
  {
    title: "Status",
    dataIndex: "payment_option",
    key: "payment_option",
    width: 150,
  },
];

const StyledButton = styled(Button)`
  box-shadow: 0px 2px 20px rgba(0, 0, 0, 0.15);
  margin-left: auto;
  margin-right: 10px;
`;

const TransactionDetail = ({ data = [] }) => {
  const rows = (data || []).map((item, index) => ({
    ...item,
    key: item.payment_id || item._id || index,
    contract_no: item.contract_no || item.contract_id || "-",
  }));

  return (
    <>
      <Tabel columns={columns} data={rows} rowKey="key" />
      <StyledButton {...btnProps}>
        <Link to="/sale-register">
          <Typography {...typoProps} noMargin />
        </Link>
      </StyledButton>
    </>
  );
};

export default TransactionDetail;
